import type {
  DownChevronIconSet,
  PropsWithDownChevronIcon,
} from "./DownChevronIcon.types";

function isDownChevronIconSet(
  x: undefined | string | DownChevronIconSet
): x is DownChevronIconSet {
  return x !== undefined && typeof x !== "string";
}

/**
 * Gets the down chevron icon from the control's props.
 * If downChevronIcon is a DownChevronIconSet, gets the appropriate size icon.
 */
export function getDownChevronIcon(
  props: Partial<PropsWithDownChevronIcon>
): string | undefined {
  if (isDownChevronIconSet(props.downChevronIcon)) {
    return props.downChevronIcon[props.downChevronIconSize || "icon12"];
  }

  return props.downChevronIcon;
}
